import * as actionTypes from './actionTypes';
import * as actions from './index';
import { getClipsForProjectSuccess, setActiveProject } from './projects';
import { setActiveRoom } from './rooms';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import Clip from 'Flow2/util/Clip';

export const getClipsForClipListStart = () => {
    return {
        type: actionTypes.GET_CLIPLIST_START
    }
}
export const getClipsForClipListFail = (error) => {
    return {
        type: actionTypes.GET_CLIPLIST_FAIL,
        error: error
    }
}
export const getClipsForClipListSuccess = (type, id, clipList) => {
    return {
        type: actionTypes.GET_CLIPLIST_SUCCESS,
        payload: { type: type, id: id, clipList: clipList }
    }
}
export const clipUpdateReceived = (clip) => {
    return {
        type: actionTypes.CLIP_UPDATE_RECEIVED,
        payload: { clip: clip }
    }
}

export const setClipList = (type, id) => {
    return {
        type: actionTypes.SET_CLIPLIST,
        payload: { type: type, id: id }
    }
}

export const getClipsForClipList = (type, clipListId) => {
    return (dispatch, getState) => {
        dispatch(getClipsForClipListStart());
        if (!type) {
            dispatch(getClipsForClipListFail('No type for Cliplist specified.'));
            dispatch(actions.applicationError('No type for Cliplist specified.'));
        }

        switch (type) {
            case 'room':
                window.flow.getShowroomById(clipListId).then((clipList) => {
                    if (clipListId != getState().clipList.activeClipListId) {
                        dispatch(actions.resetTickedClips());
                        dispatch(actions.resetMultiSelected());
                    }
                    dispatch(getClipsForClipListSuccess('room', clipList.id, clipList));
                    dispatch(setActiveRoom(clipList.id));
                }).catch((res) => {
                    console.log(res);
                    dispatch(getClipsForClipListFail(res.message));
                    dispatch(actions.applicationError(res.message));
                });
                break;
            case 'distribution':
            case 'newsroom':
            case 'pm':
            case 'article':
            case 'articleview':
            case 'articleview_mediatype':
                window.flow.getDistprojectById(clipListId).then((clipList) => {
                    if (clipListId != getState().clipList.activeClipListId) {
                        dispatch(actions.resetTickedClips());
                        dispatch(actions.resetMultiSelected());
                    }
                    dispatch(getClipsForClipListSuccess('project', clipList.id, clipList));
                    dispatch(setActiveProject(clipList.id));
                }).catch((res) => {
                    console.log(res);
                    dispatch(getClipsForClipListFail(res.message));
                    dispatch(actions.applicationError(res.message));
                });
                break;

            case 'uploadproject':
                window.flow.getProjectById(clipListId).then((clipList) => {
                    if (clipListId != getState().clipList.activeClipListId) {
                        dispatch(actions.resetTickedClips());
                        dispatch(actions.resetMultiSelected());
                    }
                    dispatch(getClipsForClipListSuccess('project', clipList.id, clipList));
                    dispatch(actions.setActiveUploadProject(clipList.id));
                }).catch((res) => {
                    console.log(res);
                    dispatch(getClipsForClipListFail(res.message));
                    dispatch(actions.applicationError(res.message));
                });
                break;
            case 'eventroom':
                window.flow.getProjectById(clipListId).then((clipList) => {
                    if (clipListId != getState().clipList.activeClipListId) {
                        dispatch(actions.resetTickedClips());
                        dispatch(actions.resetMultiSelected());
                    }
                    dispatch(getClipsForClipListSuccess('eventroom', clipList.id, clipList));
                    dispatch(actions.setActiveEventRoom(clipList.id));
                }).catch((res) => {
                    console.log(res);
                    dispatch(getClipsForClipListFail(res.message));
                    dispatch(actions.applicationError(res.message));
                });
                break;
            case 'project':
            default:
                window.flow.getProjectById(clipListId).then((clipList) => {
                    if (clipListId != getState().clipList.activeClipListId) {
                        dispatch(actions.resetTickedClips());
                        dispatch(actions.resetMultiSelected());
                    }
                    dispatch(getClipsForClipListSuccess('project', clipList.id, clipList));
                    dispatch(setActiveProject(clipList.id));
                }).catch((res) => {
                    console.log(res);
                    dispatch(getClipsForClipListFail(res.message));
                    dispatch(actions.applicationError(res.message));
                });
                break;
        }
    }
}
export const toggleCliplistFilter = (filter) => {
    return {
        type: actionTypes.CLIPLIST_TOGGLE_FILTER,
        payload: { filter: filter }
    };
};

export const setCliplistFilter = (filter) => {
    return {
        type: actionTypes.CLIPLIST_SET_FILTER,
        payload: filter
    }
}

export const clipListDownloadStart = (id) => {
    return {
        type: actionTypes.CLIPLIST_DOWNLOAD_START,
        payload: { id: id }
    }
}
export const clipListDownloadFail = (error, id) => {
    return {
        type: actionTypes.CLIPLIST_DOWNLOAD_FAIL,
        error: error,
        payload: { id: id }
    }
}
export const clipListDownloadSuccess = (id, file) => {
    return {
        type: actionTypes.CLIPLIST_DOWNLOAD_SUCCESS,
        payload: { id: id, downloadFile: file }
    }
}

export const resetDownload = () => {
    return {
        type: actionTypes.CLIPLIST_RESET_DOWNLOAD
    }
}

export const clipListDownload = (ids, clipListId = null) => {
    return (dispatch, getState) => {
        dispatch(clipListDownloadStart(clipListId));
        window.flow.newProcess('archivefiles', 'make zip', { parameters: { contenttype: 'idlist', contentlink: ids } }).then(res => {
            var interval = setInterval(function () {
                window.flow.getProcess(res.processid).then(p => {
                    console.log(p);
                    console.log(p.getStatus());
                    if (p.getStatus() == 'done') {
                        clearInterval(interval);
                        dispatch(clipListDownloadSuccess(clipListId, p.outputfileurl));
                    } else if (p.getStatus() == 'error') {
                        clearInterval(interval);
                        dispatch(clipListDownloadFail('error', clipListId));
                    }
                })
            }, 10000);
        }).catch((res) => {
            console.log(res);
            dispatch(clipListDownloadFail(res.message));
        });
    }
}

export const moveClipsToTrash = (clipIds, type, id) => {
    return (dispatch, getState) => {
        dispatch({ type: actionTypes.CLIPLIST_DELETE_START });
        window.flow.editClip(clipIds, { 'type': 'delete' }).then((clip) => {
            dispatch({ type: actionTypes.CLIPLIST_DELETE_SUCCESS });
            if (DataUtil.isPMDB() || DataUtil.isFrancetv()) {
                clipIds.split(",").forEach(item => {
                    let updatedHistory = DataUtil.updateHistoryData(getState().auth.user.id, CustomTypes.DELETE);
                    if (updatedHistory) dispatch(actions.updateMetadata("clip", item, { history: updatedHistory }));
                });
            }

            switch (type) {
                case Metadata.OBJECT_TYPE_PROJECT:
                case Metadata.OBJECT_TYPE_ROOM:
                case Metadata.OBJECT_TYPE_DISTRIBUTION:
                case Metadata.OBJECT_TYPE_EVENTROOM:
                    dispatch(actions.getClipsForClipList(type, id));
                    break;
                default:
                    break;
            }
        }).catch((res) => {
            console.log(res);
            dispatch({ type: actionTypes.CLIPLIST_DELETE_SUCCESS });
            dispatch(actions.applicationError(res.message));
        });

    }
}

export const restoreClipsFromTrash = (clipIds) => {
    return dispatch => {
        dispatch({ type: actionTypes.CLIPLIST_RESTORE_START });
        window.flow.editClip(clipIds, { 'type': 'active' }).then((clip) => {
            dispatch({ type: actionTypes.CLIPLIST_RESTORE_SUCCESS });
        }).catch((res) => {
            console.log(res);
            dispatch({ type: actionTypes.CLIPLIST_RESTORE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    }
}

export const deleteClips = (ids) => {
    return (dispatch, getState) => {
        dispatch({ type: actionTypes.CLIPLIST_DELETE_START });
        window.flow.delClip(ids).then((clip) => {
            dispatch({ type: actionTypes.CLIPLIST_DELETE_SUCCESS });

            dispatch(actions.getClipLimit(getState().app.modules.modules));
        }).catch((res) => {
            console.log(res);
            dispatch({ type: actionTypes.CLIPLIST_DELETE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    }
}

export const getClipById = (id) => {
    return (dispatch, getState) => {
        dispatch({ type: actionTypes.GET_CLIP_BY_ID_START });
        //window.flow.getClipsByFields([{ field: 'id', type: 'IDLIST', value: id }]).then((res) => {
        //console.log("LAMTEST getClipById", id);
        window.flow.getClipById(id).then((res) => {
            //dispatch({ type: actionTypes.GET_CLIPLIST_BY_ID_SUCCESS, payload: { clipList: res } });
            dispatch({ type: actionTypes.GET_CLIP_BY_ID_SUCCESS, clip: res, id: id });

            // refresh current clip with new data
            if (getState().clip.currentClip && getState().clip.currentClip.id && getState().clip.currentClip.id == id) {
                dispatch(actions.selectClip(Clip.parseClip(res), getState().clipList.playerDerivatives));
            }
        }).catch((res) => {
            console.log(res);
            dispatch({ type: actionTypes.GET_CLIP_BY_ID_FAIL, error: res.message });
            dispatch(actions.applicationError(res.message));
        });
    }
}

export const getCliplistByIds = (ids) => {
    let idList = ids;

    // create ',' separated string of ids 
    if (Array.isArray(idList)) {
        idList = idList.join(',');
    }

    return (dispatch, getState) => {
        dispatch({ type: actionTypes.GET_CLIPLIST_START });
        window.flow.getClipsByFields([{ field: 'id', type: 'IDLIST', value: idList }]).then((res) => {
            const id = getState().clip.currentClip.id;
            if (id && res.clip.elements[id]) {
                //console.log("CURRENT UPDATE");
                dispatch(actions.selectClip(Clip.parseClip(res.clip.elements[id]), getState().clipList.playerDerivatives));
            }
            dispatch({ type: actionTypes.GET_CLIPLIST_BY_ID_SUCCESS, payload: { clipList: res } });
        }).catch((res) => {
            console.log(res);
            dispatch({ type: actionTypes.GET_CLIPLIST_FAIL, error: res.message });
            dispatch(actions.applicationError(res.message));
        });
    }
}

// ids: comma seperated string
export const getRelatedClipList = (ids) => {
    return dispatch => {
        dispatch({ type: actionTypes.GET_CLIPLIST_START });
        window.flow.getClipsByFields([{ field: 'id', type: 'IDLIST', value: ids }]).then((res) => {
            dispatch({ type: actionTypes.GET_CLIPLIST_BY_ID_SUCCESS, payload: { clipList: res } });
        }).catch((res) => {
            dispatch({ type: actionTypes.GET_CLIPLIST_FAIL, error: res.message });
            dispatch(actions.applicationError(res.message));
        });
    }
}


export const getRelatedClips = (ids, loadRes = false) => {
    return dispatch => {
        const idArray = !Array.isArray(ids) ? [ids] : [...ids];
        dispatch({ type: actionTypes.RELATED_CLIPS_GET_START });
        window.flow.relatedClips(idArray).then((res) => {
//            console.log(res);
            if (loadRes) {
                for (let id in res) {
                    const otherIds = res[id].toother.map(other => other.clipb_id);
                    const tome = res[id].tome.map(me => me.clipa_id);
                    const allIds = [...tome, ...otherIds];
                    dispatch(getRelatedClipList(allIds.join(',')/*otherIds.join(',') + tome.join(',')*/));
                }
            }
            //console.log(res);
            dispatch({ type: actionTypes.RELATED_CLIPS_GET_SUCCESS, res: res });
        }).catch((res) => {
            dispatch({ type: actionTypes.RELATED_CLIPS_GET_FAIL });
        });
    }
}


export const arrangeClipList = (clipIds, refClipId, pos) => {
    return dispatch => {
        dispatch({ type: actionTypes.ARRANGE_CLIPLIST_START });
        dispatch({ type: actionTypes.ARRANGE_CLIPLIST_AND_END, payload: { clipIds: clipIds, refClipId: refClipId, pos: pos } });
    }
}

export const saveArrangedClipList = (type = '') => {
    return (dispatch, getState) => {
        const clipListId = getState().clipList.activeClipListId;
        const clipLists = getState().clipList.clipLists;
        if (clipListId) {
            dispatch({ type: actionTypes.SAVE_ARRANGED_CLIPLIST_START });
            let SAVEARRANGED = type && type === 'rooms' ? "showroomOrderClips" : "projectOrder";
            if (!window.flow[SAVEARRANGED]) SAVEARRANGED = "projectOrder";
            window.flow[SAVEARRANGED](clipListId, clipLists[clipListId].clips).then((res) => {
                dispatch({ type: actionTypes.SAVE_ARRANGED_CLIPLIST_SUCCESS });
            }).catch((res) => {
                console.log(res);
                dispatch({ type: actionTypes.SAVE_ARRANGED_CLIPLIST_FAIL, error: res.message });
                dispatch(actions.applicationError(res.message));
            });
        }
    }
}

export const checkTranscoding = (start = true) => {
    return (dispatch, getState) => {
        // get correct host
        const config = getState().ui.config;
        //console.log(config);
        let url = window.location.origin;
        if (window.location.origin.indexOf("localhost") !== -1) {
            if (config.DEV_HOST) {
                url = config.DEV_HOST;
            }
        }
        if (start) {
            let interval = setInterval(function () {
                fetch(url + '/processstatus.json')
                    .then(response => response.json())
                    .then((jsonData) => {
                        const state = getState().clipList;
                        if (state.transcoding) {
                            state.transcoding.forEach((id) => {
                                if (jsonData.indexOf(id) === -1) {
                                    dispatch(actions.getClipById(id));
                                    console.log("TRANSCODING: old ids", state.transcoding);
                                    console.log("TRANSCODING: new ids", jsonData);
                                }
                            });
                        }

                        // jsonData is parsed json object received from url
                        dispatch({ type: actionTypes.CHECK_TRANSCODING_SUCCESS, transcoding: jsonData });
                    })
                    .catch((error) => {
                        console.log("JSON ERROR");
                        dispatch({ type: actionTypes.CHECK_TRANSCODING_END });
                    });
            }, 10000);

            dispatch({ type: actionTypes.CHECK_TRANSCODING_START, transcodingChecker: interval });
        } else {
            dispatch({ type: actionTypes.CHECK_TRANSCODING_END });
        }
    }
}

export const loadClipByInternalLink = (id) => {
    return dispatch => {
        dispatch({ type: actionTypes.LOAD_CLIP_BY_INTERNAL_LINK, id: id });
        dispatch(actions.getClipById(id));
    }
}

export const removeClipByInternalLink = (id) => {
    return dispatch => {
        dispatch({ type: actionTypes.REMOVE_CLIP_BY_INTERNAL_LINK, id: id });
    }
}

export const setupClipListFields = (fields) => {
    return dispatch => {
        dispatch({ type: actionTypes.CLIPLIST_SETUP_LIST_FIELDS, fields: fields });
    }
}

export const zoomCliplist = (size) => {
    return dispatch => {
        dispatch({ type: actionTypes.CLIPLIST_ZOOM, size: size });
    }
}
